import { ITrackEventData } from 'interfaces/analytics';
import { trackEvent } from './Analytics';

export const onPlayerStateChange = (event: any) => {
  var percentageInterval: any;
  var videoPercentages = [100, 75, 50, 25, 10];
  const pageSection = getCategoryText();
  var trackingObject: ITrackEventData = {
    label: '',
    category: {
      includePageName: false,
      text: pageSection,
    },
    type: 'video',
    video: {
      videoTitle: event.target.getVideoData().title,
      videoEventDuration: event.target.getDuration(),
      videoId: event.target.getVideoData().video_id,
      videoLink: event.target.getVideoUrl(),
    },
  };

  // If Video Play
  if (event.data === 1 && trackingObject.video) {
    trackingObject.video.videoAction = 'Play';
    trackingObject.label = `${pageSection}:play ${trackingObject.video.videoTitle?.toLowerCase()}`;
    trackEvent(trackingObject);
    clearInterval(percentageInterval);

    // Interval to check the percentages watched on the video
    percentageInterval = setInterval(function () {
      var currentPercentage =
        (event.target.getCurrentTime() * 100) / event.target.getDuration();
      if (
        videoPercentages.length > 0 &&
        trackingObject.video &&
        videoPercentages[videoPercentages.length - 1] <= currentPercentage
      ) {
        videoPercentages =
          updatePercentages(currentPercentage, videoPercentages) || [];
        trackingObject.video.videoMilestone =
          Math.floor(currentPercentage) + '%';
        trackingObject.video.videoAction = 'milestone';
        trackingObject.label = `${pageSection}:milestone ${trackingObject.video.videoTitle?.toLowerCase()}`;
        trackEvent(trackingObject);
      }
    }, 400);
    // If Video Pause
  } else if (event.data === 2 && trackingObject.video) {
    trackingObject.video.videoAction = 'Paused';
    trackingObject.label = `${pageSection}:pause ${trackingObject.video.videoTitle?.toLowerCase()}`;
    trackEvent(trackingObject);
    clearInterval(percentageInterval);
    // Video End
  } else if (event.data === 0 && trackingObject.video) {
    // sending 100% checkpoint event
    trackingObject.video.videoAction = 'milestone';
    trackingObject.label = `${pageSection}:milestone ${trackingObject.video.videoTitle?.toLowerCase()}`;
    trackingObject.video.videoMilestone = '100%';
    trackEvent(trackingObject);
    clearInterval(percentageInterval);
    event.target.stopVideo();
  }
};

function updatePercentages(
  currentPercentage: number,
  videoPercentages: number[]
) {
  for (var i = videoPercentages.length - 1; i >= 0; i--) {
    if (currentPercentage > videoPercentages[i]) {
      videoPercentages.pop();
    } else {
      return videoPercentages;
    }
  }
}

function getCategoryText() {
  const Acr = window.Acr || {};
  return Acr.dataLayer?.EventMetadata?.action_category || '';
}
